<template>
  <span
    class="badge d-inline-flex align-items-center justify-content-center me-2 mb-2 px-2 py-1"
    :class="badgeClass"
  >
    <!-- Label -->
    <span class="me-1 ">{{ label }}</span>

    <!-- Close button -->
    <button
      v-if="closable"
      type="button"
      class="text-xs text-white btn-close btn-close-white"
      aria-label="Remove"
      style="width: 1rem; height: 1rem;"
      @click.stop="$emit('remove')"
    ></button>
  </span>
</template>

<script>
export default {
  name: "MaterialSelectedBadge",
  props: {
    label: { type: String, required: true },
    closable: { type: Boolean, default: false },
    color: { type: String, default: "info" }, // Bootstrap bg-* variant
  },
  computed: {
    badgeClass() {
      return `bg-${this.color}`;
    },
  },
  emits: ["remove"],
};
</script>

<style scoped>
.badge {
  font-size: 0.85rem;
  font-weight: normal;
  text-transform: capitalize;
}
</style>